import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "inclusion-card-wr" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = ["src"]
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString($setup.capitalizeFirstLetter($setup.props.inclusion.type)), 1),
      _createElementVNode("button", {
        class: "button default edit edit-icon",
        onClick: $setup.openEditModal
      }),
      _createElementVNode("button", {
        class: "button button-with-icon trash-icon",
        onClick: $setup.deleteInclusion
      }, [
        _createElementVNode("img", {
          class: "trash-icon-img",
          src: require(`@/assets/icons/trash.svg`)
        }, null, 8, _hoisted_4)
      ]),
      _createElementVNode("button", {
        class: "button default details details-icon",
        onClick: $setup.openDetailsModal
      }, [
        _createElementVNode("img", {
          class: "details-icon-img",
          src: require(`@/assets/icons/icon-question.svg`)
        }, null, 8, _hoisted_5)
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("ul", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.props.inclusion.inclusions, (inclusion, index) => {
          return (_openBlock(), _createElementBlock("li", { key: index }, _toDisplayString(inclusion.name), 1))
        }), 128))
      ])
    ]),
    _createVNode($setup["InclusionDetailModal"], {
      isOpen: $setup.isDetailsModalOpen,
      inclusion: $setup.selectedInclusion,
      onClose: $setup.closeDetailsModal
    }, null, 8, ["isOpen", "inclusion"]),
    _createVNode($setup["AddAndUpdateInclusionModal"], {
      isOpen: $setup.isEditModalOpen,
      builderId: $setup.props.builderId,
      mode: "update",
      inclusion: $setup.selectedInclusion,
      onConfirm: _cache[0] || (_cache[0] = ($event: any) => (_ctx.reloadInclusionGallery = true)),
      onClose: $setup.closeEditModal,
      onUpdateInclusion: $setup.updateInclusion
    }, null, 8, ["isOpen", "builderId", "inclusion"])
  ]))
}